<template>
  <div >
    <div class="personalize_prof">
      <h1> {{ getTranslations.home_profile_profile_edit_set_profile_picture }} </h1>
      <div class="swiper personalize_prof_carousel">
        <div class="owl-carousel swiper-wrapper">
<!--          <div classs="item">-->
<!--            <img :class="[(selectedAvatar === 3) ? 'prof_img selected' : 'prof_img']"-->
<!--                 @click.prevent="changeSelectedAvatar(3)"-->
<!--                 style="cursor: pointer"-->
<!--                 :src="getAvatarImage(3)" />-->
<!--          </div>-->
          <div class="item" v-for="imageIndex in numberOfAvatarImages"  :key="imageIndex.type"  >
            <img :class="[(selectedAvatar === imageIndex) ? 'prof_img selected' : 'prof_img']"
                 style="cursor: pointer"
                 @click.prevent="changeSelectedAvatar(imageIndex)"
                 :key="imageIndex"
                 :src="getAvatarImage(imageIndex)">
          </div>
        </div>
        <div class="carousel__nav"></div>

      </div>


    </div>
    <div class="circle_background">
      <button :class="['btn_select_profile', selectedAvatar === '' ? 'deactivated' : '']" @click.prevent="changeAvatar()">
        {{ getTranslations.home_profile_profile_edit_select }}
      </button>
      <profile-edit></profile-edit>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import 'owl.carousel';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import FacebookLogin from '@/components/visitor/FacebookLogin';
import ProfileEdit from './ProfileEdit';

export default {
  name: 'edit-avatar',
  data() {
    return {
      selectedAvatar: '',
      numberOfAvatarImages: 28,
      errorInConnectFb: false,
      fbActionType: 'connect',
    };
  },
  components: {
    ProfileEdit,
    FacebookLogin,
  },
  mounted() {
    this.$nextTick(() => {
      /*eslint-disable */
      // default home page carousel
      $('.owl-carousel').owlCarousel({
        loop: false,
        rtl: false,
        responsiveClass: true,
        autoplay: false,
        autoplayHoverPause: true,
        navContainer: '.carousel__nav',
        dotsContainer: '.carousel__dots',
        margin: 20,
        navText: ['<i class="icon-arrow-left swiper-button-prev"></i>', '<i class="icon-arrow-right swiper-button-next"></i>'] ,
        responsive: {
          0: {
            items: 5,
            nav: true
          },
          768: {
            items: '5',
            spaceBetween: 0,
          },
          500: {
            items: '4',
            spaceBetween: 0,
          },
          321: {
            items: '3',
            spaceBetween: 0,
          },
          0: {
            items: '2',
            spaceBetween: -20,
          },
        }
      });
    });
    $(".item").click(function(){

        $(this).find(".prof_img").toggleClass("selected").parent().siblings().find(".prof_img").removeClass("selected");

        var src_2 = $(this).find(".prof_img").attr('src');

    });
  },
  created() {
    if (!this.userAvatar) this.selectedAvatar = 0; // default
    this.setProfilePath(true);
  },
  methods: {
    ...mapActions('common', [
      'sendAvatarCall',
    ]),
    ...mapMutations('common', [
      'setProfilePath',
    ]),
    methodForEvent(event) {
      this.errorInConnectFb = event;
    },
    getAvatarImage(imageIndex) {
      let gender = 'male';
      let realIndex = imageIndex;
      const halfImages = this.numberOfAvatarImages / 2;
      if (halfImages < imageIndex) {
        gender = 'female';
        realIndex = imageIndex - halfImages;
      }
      return `/static/images/avatar_${this.avatarGrouping}/Avatar_${realIndex}_${gender}.png`;
    },
    getGender(imagePath) {
      if (imagePath.includes('default')) return this.userDetails.avatarGender;
      return imagePath.includes('female') ? 'female' : 'male';
    },
    changeAvatar() {
      let newAvatarPath = '/static/images/avatar-default.svg';
      if (this.selectedAvatar) newAvatarPath = this.getAvatarImage(this.selectedAvatar);
      localStorage.setItem('Avatar', newAvatarPath);
      this.sendAvatarCall(this.getGender(newAvatarPath));
    },
    changeSelectedAvatar(index) {
      this.selectedAvatar = index;
    },
    hasFbButton() {
      return this.$route.path === '/home/profile/edit'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userAvatar',
      'userDetails',
      'profilePath',
      'facebookFunctionality',
      'avatarGrouping',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/EditAvatar.vue